import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { ViewerRequestModel } from 'src/app/models/viewer/viewer-request-model.model';

/**
 * API client for the Viewer-Request API
 */
@Injectable({
    providedIn: 'root'
})
export class ViewerRequestApiClient {

    private ControllerEndpoint: string = environment.apiUrl + "/fe-api/viewer-request/";


    constructor(private httpClient: HttpClient) { }

    /**
     * Get the Request for Viewer
     * @param requestGuid 
     */
    Get(requestGuid: string): Observable<ViewerRequestModel> {
        return this.httpClient.get<ViewerRequestModel>(this.ControllerEndpoint + requestGuid);
    }
}
